module.exports = __webpack_public_path__ + "img/failed.32246e56.png";